<template>
  <div class="login">
    <div class="login-title">
      <div class="back" @click="goBack()">
        <van-icon name="arrow-left" />
      </div>
      <p>登录</p>
    </div>
    <div class="loginDiv">
      <div class="login-div">验证码登录</div>
      <div class="login-phone">
        <input
          v-model="phoneValue"
          class="login-input"
          type="text"
          placeholder="输入手机号码"
        />
      </div>
      <div class="login-yzm">
        <div>
          <input
            v-model="yzmValue"
            class="login-input"
            type="text"
            placeholder="输入6位数验证码"
          />
        </div>
        <p v-if="!numTF" @click="changeNum()">获取验证码</p>
        <p v-if="numTF">{{ num }}s</p>
      </div>
    </div>
    <div class="loginButton" @click="submitData()" v-if="!loginTF">
      <div>登录</div>
    </div>
    <div class="loginButton" v-if="loginTF"><div>登录</div></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { yzmLogin, getYzm, getUserInfo } from "../api/common";
export default {
  name: "login",
  data() {
    return {
      url: "",
      phoneValue: "",
      loginTF: false,
      num: 59,
      numTF: false,
      numInterval: "",
      yzmValue: "",
      originCode: 304,
      data: {},
      phoneYz:
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
    };
  },
  mounted() {
    this.url = this.$route.params.url;
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeNum() {
      if (!this.phoneYz.test(this.phoneValue)) {
        Toast("请输入正确手机号");
      } else {
        let params = {
          phone: this.phoneValue,
          origin: this.originCode,
        };
        getYzm(params).then((res) => {
          if (res.status == "success") {
            Toast("发送成功");
            this.numTF = true;
            this.numInterval = setInterval(() => {
              if (this.num == 0) {
                this.numTF = false;
              } else {
                this.num -= 1;
              }
            }, 1000);
          } else {
            Toast(res.msg);
          }
        });
      }
    },
    submitData() {
      if (this.phoneValue == "" || this.yzmValue == "") {
        Toast("手机号和验证码不能为空");
      } else {
        this.loginTF = true;
        let params = {
          phone: this.phoneValue,
          validCode: this.yzmValue,
          origin: this.originCode,
          wxJsonData: "",
        };
        yzmLogin(params).then((res) => {
          this.loginTF = false;
          Toast(res.msg);
          window.localStorage.setItem("userToken", res.data.token);
          this.getPersonInfo(res.data.token);
        });
      }
    },
    getPersonInfo(token) {
      let params = {
        token: token,
      };
      getUserInfo(params).then((res) => {
        window.localStorage.setItem("userId", res.data.userId);
        if (this.url) {
          window.location.replace(this.url);
        } else {
          window.location.replace(window.location.origin);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.login-title {
  width: 100%;
  background-color: #fff;
  padding: 14px 0;
  box-shadow: 0px 7px 7px -2px rgba(228, 228, 228, 0.7);
  position: relative;
  .back {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 12px;
    color: #344058;
    display: flex;
    height: 100%;
    align-items: center;
    i {
      font-size: 20px;
    }
  }
  p {
    font-size: 16px;
    color: #344058;
    text-align: center;
  }
}
.loginDiv {
  padding: 20px;
  .login-div {
    font-size: 17px;
    color: #344058;
  }
  .login-phone {
    border-bottom: 1px solid #e6e6e6;
    input {
      height: 54px;
    }
  }
  .login-yzm {
    display: flex;
    align-items: center;
    input {
      height: 54px;
    }
    div {
      flex: 1;
      border-bottom: 1px solid #e6e6e6;
    }
    p {
      width: 90px;
      text-align: center;
      font-size: 13px;
      color: #5072b9;
    }
  }
  .login-input {
    font-size: 15px;
    color: #8692ac;
    border: 0;
  }
}
.loginButton {
  padding: 0 15px;
  margin-top: 15px;
  div {
    width: 100%;
    height: 40px;
    background: #344058;
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
    font-size: 13px;
    color: #fff;
  }
}
</style>
